/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

import { overflowEllipsis } from 'src/styles/mixins';

export const FiltersContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: `${gridSize() * 1.5}px`,
  flexWrap: 'wrap',
  marginTop: `-${gridSize()}px`,
});

export const PrivacyFilterContainer = styled.div(
  {
    marginTop: `-${gridSize() * 0.5}px`,
    marginLeft: `${gridSize() * 2}px`,
  },
  media.upToMedium(`
    margin-left: 0;
  `)
);

export const FilterLabel = styled.div({
  marginRight: `${gridSize()}px`,
  whiteSpace: 'nowrap',
});

export const LanguagesFilterContainer = styled.div({
  marginTop: `-${gridSize() * 0.5}px`,
  marginLeft: `${gridSize()}px`,
});

export const WatchingFilterContainer = styled.div({
  marginTop: `-${gridSize() * 0.5}px`,
  marginLeft: `${gridSize()}px`,
});

export const SearchContainer = styled.div(
  {
    width: `${gridSize() * 23}px`,
    marginTop: `${gridSize()}px`,
  },
  media.upToMedium(`
    width: 100%;
    margin-right: 0;
  `)
);

export const ProjectContainer = styled.div(
  {
    marginTop: `-${gridSize() * 0.5}px`,
    marginLeft: `${gridSize() * 2}px`,
  },
  media.upToMedium(`
    width: 100%;
    margin-right: 0;
  `)
);

export const Ellipsis = styled.div(overflowEllipsis('100%'));
